module.exports = __webpack_public_path__ + "img/kerrang.4ade8bfc.png";